/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 忘记密码第一步,校验用户名是否正确,返回uuid,在第二步使用
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  retrievePasswordDto: member.RetrievePasswordDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/retrieving-password/username`,
    data: retrievePasswordDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
